import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=2268ff3e&scoped=true&"
import script from "./HelloWorld.vue?vue&type=script&lang=ts&"
export * from "./HelloWorld.vue?vue&type=script&lang=ts&"
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=2268ff3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2268ff3e",
  null
  
)

export default component.exports